import { Article } from '@generated'
import { requiredRCPOAttributes } from '../hooks/use-rcpo-data'

export function hasSufficientProductData(data: Article): boolean {
  const hasBasics =
    data && data.id && data.price && data.modelName && data.images && data.images.length > 0

  if (!hasBasics) {
    return false
  }

  const hasRequiredAttributes = requiredRCPOAttributes.every((id) => {
    return data?.articleAttributes?.some((attribute) => attribute?.attributeID === id)
  })

  return hasRequiredAttributes
}
